const url = window.location.href;
const result = url.includes("form_type=customer");

const newsletterForm = document.querySelector('#NewsletterSectionForm');
const inputs = document.querySelectorAll('input.newsletter-v2__container__inner__right__form__container__input[type="email"]');
let already_subscribed = false;

function smoothScroll(target, duration) {
  const startingY = window.pageYOffset;
  const targetY = target.getBoundingClientRect().top + startingY - 90;
  const distance = targetY - startingY;
  let startTime = null;

  function scrollAnimation(currentTime) {
    if (!startTime) startTime = currentTime;
    const timeElapsed = currentTime - startTime;
    const nextPosition = Math.easeInOutQuad(
      timeElapsed,
      startingY,
      distance,
      duration
    );

    window.scrollTo(0, nextPosition);

    if (timeElapsed < duration) {
      requestAnimationFrame(scrollAnimation);
    }
  }

  requestAnimationFrame(scrollAnimation);
}

Math.easeInOutQuad = function (t, b, c, d) {
  t /= d / 2;
  if (t < 1) return (c / 2) * t * t + b;
  t--;
  return (-c / 2) * (t * (t - 2) - 1) + b;
};

if (newsletterForm) {
  inputs.forEach((input) => {
    const form_posted_successfully = newsletterForm.querySelector("input[name='lbc[form_posted_successfully]']");
    const shopifyErrors = newsletterForm.querySelector(".newsletter-v2__container__inner__right__form__error-message--shopify-errors");

    if (result && !form_posted_successfully && !shopifyErrors) {
      const input_form = input.closest("#NewsletterSectionForm");
      const already_subscribed_error = input_form.querySelector(".js-lbc-already-subscribed");
  
      already_subscribed_error.style.display = "block";
  
      already_subscribed = true;
      
      smoothScroll(newsletterForm, 500);
  
      // Remove all parameters from URL
      const url = window.location.href.split("?")[0];
      history.replaceState(null, "", url);
    }
  });
}
